// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--effa86","reviewPanel":"style--reviewPanel--0b58a2"};